export const GET_ME_ENDPOINT = '/auth/me'
export const GET_WORKFORCES_ENDPOINT = '/organization/workforces'
export const GET_PRODUCT_SWITCHER_ENDPOINT = '/user-settings/product-switcher'
export const REFRESH_TOKEN_ENDPOINT = '/auth/refresh-token'
export const GENERATE_TOKEN_ENDPOINT = '/auth/generate-token'
export const GET_UPCOMING_TASKS_ENDPOINTS = '/initiatives/upcoming-tasks'
export const GET_HOME_TEMPLATES_ENDPOINT = '/templates/home'
export const GET_INITIATIVE_OWNERS_ENDPOINT = '/initiatives/owners'
export const GET_INITIATIVE_FILTERS_ENDPOINT = '/initiatives/filters'
export const GET_INITIATIVES_TABLE_ENDPOINT = '/initiatives/table'
export const GET_INITIATIVES_GRID_ENDPOINT = '/initiatives/grid'
export const CREATE_DIALOG_ENDPOINT = '/dialogs'
export const GET_DIALOG_DETAILS_ENDPOINT = (id: string): string =>
  `/dialogs/${id}`
export const GET_DIALOGS_ENDPOINT = '/dialogs'
export const GET_DIALOG_COUNT_ENDPOINT = '/dialogs/count'
export const UPDATE_DIALOG_ENDPOINT = '/dialogs'
export const DIALOG_USER_AVATAR_ENDPOINT = '/dialog-user-avatar'
export const CREATE_DIALOG_RESPONSE_ENDPOINT = '/dialogs/responses'
export const UPDATE_DIALOG_RESPONSE_ENDPOINT = (id: string): string =>
  `/dialogs/responses/${id}`
export const DELETE_DIALOG_RESPONSE_ENDPOINT = (id: string): string =>
  `/dialogs/responses/${id}`
export const ADD_DIALOG_RESPONSE_REACTION_ENDPOINT = (
  responseId: string,
): string => `/dialogs/responses/${responseId}/reactions`
export const CREATE_DIALOG_RESPONSE_REPLY_ENDPOINT = '/dialog-response-replies'
export const ADD_DIALOG_RESPONSE_REPLY_ENDPOINT = '/dialog-response-replies'
export const DELETE_DIALOG_RESPONSE_REPLY_ENDPOINT = (id: string): string =>
  `/dialog-response-replies/${id}`
export const GET_HIGHLIGHTED_RESPONSES_ENDPOINT = (dialogId: string): string =>
  `/dialogs/responses/highlighted?dialogId=${dialogId}`
export const GET_STATUS_SUMMARY_ENDPOINT = '/analytics/status-summary'
export const CREATE_INITIATIVE_ENDPOINT = '/initiatives'
export const CREATE_INITIATIVE_WITH_TASKS_ENDPOINT = '/initiatives/with-tasks'
export const UPDATE_INITIATIVE_ENDPOINT = '/initiatives'
export const DELETE_INITIATIVE_ENDPOINT = '/initiatives/recycle'
export const GET_INITIATIVE_ENDPOINT = '/initiatives'
export const GET_RECYCLE_BIN_ENDPOINT = '/initiative/recycle-bin'
export const DELETE_RECYCLE_BIN_ENDPOINT =
  '/initiative/recycle/empty-recycle-bin'
export const RESTORE_INITIATIVE_ENDPOINT = (id: string): string =>
  `/initiative/recover/${id}`
export const GET_STATS_ENDPOINT = '/analytics/statistics'
export const GET_TOP_GOALS_ENDPOINT = '/analytics/top-goals'
export const GET_TOP_CONTRIBUTOR_ENDPOINT = '/analytics/top-contributors'
export const GET_TOP_IDEAS_ENDPOINT = '/analytics/top-ideas'
export const GET_IDEATIONS_ENDPOINT = '/ideations'
export const CREATE_IDEATION_ENDPOINT = '/ideations'
export const UPDATE_IDEATION_ENDPOINT = '/ideations'
export const GET_IDEATION_ENDPOINT = '/ideations'
export const DELETE_IDEATIONS_ENDPOINT = '/ideations'
export const UPDATE_IDEATION_QUESTION_ENDPOINT = '/ideations/questions'
export const CREATE_DEFAULT_IDEA_ENDPOINT = '/ideas/default'
export const GET_PUBLISH_IDEATION_ENDPOINT = '/ideations/preview/publish'
export const GET_DRAFT_IDEATION_ENDPOINT = '/ideations/preview/draft'
export const CREATE_IDEA_ENDPOINT = '/ideas'
export const CREATE_IDEAS_VOTE_ENDPOINT = '/ideas/vote'
export const CREATE_IDEA_COMMENTS_ENDPOINT = '/ideas/comment'
export const GET_TOP_IDEAS_IDEATION_ENDPOINT = '/ideations'
export const UPDATE_PARTICIPANTS_ENDPOINT = '/ideations/participants'
export const GET_TASK_RECOMMENDATION_SURVEYS_ENDPOINT =
  '/task-recommendations/surveys'
export const GENERATE_TASK_RECOMMENDATIONS_ENDPOINT = '/task-recommendations'
export const CREATE_TASK_ENDPOINT = '/tasks'
export const GET_INITIATIVE_PEOPLE_ENDPOINT = '/initiatives'
export const CREATE_GOAL_ENDPOINT = '/goals'
export const DELETE_GOAL_ENDPOINT = (id: string | number): string =>
  `/goals/${id}`
export const UPDATE_GOAL_ENDPOINT = '/goals'
export const SAVE_FILTER_ENDPOINT = '/teams-view/filter'
export const GET_SETTINGS_ENDPOINT = '/settings'
export const UPDATE_SETTINGS_ENDPOINT = '/settings'
export const UPDATE_USER_SETTINGS_ENDPOINT = '/user-settings'
export const GET_HUDDLES_ENDPOINT = '/huddles'
export const CREATE_HUDDLE_ENDPOINT = '/huddles'
export const UPDATE_HUDDLE_ENDPOINT = '/huddles'
export const DELETE_HUDDLE_ENDPOINT = (id: string): string => `/huddles/${id}`
export const GET_TEAMS_VIEW_CUSTOM_FIELDS_ENDPOINT = '/teams-view/custom-fields'
export const GET_TEAMS_VIEW_FILTER_ENDPOINT = '/teams-view/filter'
export const SAVE_TEAMS_VIEW_FILTER_ENDPOINT = (id: string): string =>
  `/teams-view/filter/${id}`
export const GET_TEAMS_VIEW_USER_TASKS_ENDPOINT = '/teams-view/user-tasks'
export const GET_TEAMS_VIEW_USER_INITIATIVES_ENDPOINT =
  '/teams-view/user-initiatives'
export const GET_USER_TASKS_ENDPOINT = '/teams-view/user-tasks'
export const GET_TEAMS_VIEW_USERS_ENDPOINT = '/teams-view/users'
export const GET_ORGANIZATION_USERS_ENDPOINT = '/organization/users'
export const GET_EMPLOYEE_USERS_ENDPOINT = '/organization/users'
export const GET_TASKS_ENDPOINT = '/tasks'
export const UPDATE_TASK_STATUS_ENDPOINT = '/tasks/status'
export const UPDATE_TASK_BLOCK_ENDPOINT = '/tasks/block'
export const UPDATE_TASK_ENDPOINT = '/tasks'
export const DELETE_TASKS_ENDPOINT = '/tasks'
export const BULK_CREATE_TASKS_ENDPOINT = '/tasks/bulk'
export const TASK_COMMENTS_ENDPOINT = (taskId: string): string =>
  `/tasks/${taskId}/comments`
export const TASK_COMMENT_ENDPOINT = (
  taskId: string,
  commentId: string,
): string => `/tasks/${taskId}/comments/${commentId}`
// No `admin/` prefix: getApiBaseUrl() adds it on the admin host.
export const INITIATIVE_ACTIVITY_ENDPOINT = (initiativeId: string): string =>
  `/initiatives/${initiativeId}/activity`
export const GET_TEMPLATES_ENDPOINT = '/templates'
export const CREATE_TEMPLATE_ENDPOINT = '/templates'
export const GET_TEMPLATE_ENDPOINT = '/templates'
export const GET_TEMPLATE_IMAGES_ENDPOINT = '/templates/all-images'
export const UPLOAD_TEMPLATE_IMAGE_ENDPOINT = '/templates/upload-image'
export const GET_GENERAL_GOALS_ENDPOINT = '/goals'
export const GET_DASHBOARD_ANALYTICS_ENDPOINT = '/dashboard/analytic'
export const GET_USER_SESSION_LIST_ENDPOINT = '/dashboard/sessions'
export const TEMPLATE_TO_HOME_ENDPOINT = '/templates/home'
export const GET_IDEATION_INSIGHTS_ENDPOINT = '/insights/:ideationId'
export const UPDATE_TEMPLATE_ENDPOINT = '/templates'
export const DELETE_TEMPLATE_ENDPOINT = '/templates/:id'
export const DELETE_TEMPLATE_IMAGE_ENDPOINT = '/templates/images/:id'
export const GET_TOP_INTERACTIONS_ENDPOINT =
  '/dialogs/responses/top-interactions'
export const GET_DIALOG_ANALYTICS_ENDPOINT = '/dialogs/analytics/generate'
export const GET_SAVED_DIALOG_ANALYTICS_ENDPOINT = '/dialogs/analytics/saved'
export const EXPORT_ANALYTICS_ENDPOINT = '/analytics/export'
export const GET_FLAGGED_RESPONSES_ENDPOINT = (id: string): string =>
  `/dialogs/violated?dialogId=${id}`
export const PATCH_FLAGGED_RESPONSES_ENDPOINT = (id: string): string =>
  `/dialogs/responses/${id}/status`
export const PATCH_FLAGGED_REPLIES_ENDPOINT = (id: string): string =>
  `/dialog-response-replies/${id}/status`
